export default "__VITE_ASSET__BxkirtNO__"